import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ withSmallIcon: boolean }>()(
  (theme: Theme, { withSmallIcon }) => ({
    root: {
      height: theme.spacing(3.25),
      backgroundColor: theme.palette.background.default,
      fontSize: theme.spacing(1.5),
      border: `${theme.spacing(0.125)} solid ${theme.palette.primary.light}`,

      '& span.MuiChip-label': {
        [theme.breakpoints.down('x-xs')]: {
          paddingLeft: theme.spacing(withSmallIcon ? 0 : 1.5),
        },
      },
    },

    button: {
      color: theme.palette.text.primary,
    },
  })
);
